module.exports = __webpack_public_path__ + "img/Oktoberfest_2018.3e542b33.jpg";